<template> 
  <div class="fill-height posRelative">
    <v-layout
      class="fill-height ma-0"
      v-show="!dragOverStatus"
      row
      wrap
    >
      <v-flex
        class="pa-0 fill-height"
        :class="{
          'afficheInfos':afficheInfos,
          'cacheInfos':!afficheInfos,
          'mobileShowInfosVisiteur': $vuetify.breakpoint.xsOnly,
          'xs7': bigHeightChat,
          'xs12': !bigHeightChat,
          'infos-panel--large': !bigHeightChat
        }"
        v-show="!bigWidthChat || !bigHeightChat"
      >
        <wz-content-infos-visiteur
          v-if="dataCompletVisiteur && chatSessionActive"
          :datasVisiteur="dataCompletVisiteur"
          :datasPupitreVisiteur="datasViewPupitre"
          class="cardInfosVisiteurPupitre"
          :placesPupitre="placesPupitre"
          :selectedAgent="selectedAgent"
          ref='infos'
          :msg.sync="msg"
          @sendMsg="msg => $refs.fenetreChat.sendMessage(msg)"
          @cacheInfosVisiteur="cacheInfosVis"
        >
        </wz-content-infos-visiteur>
        <div v-else-if="!dataCompletVisiteur && chatSessionActive" class="flex">
          <v-alert type="warning" :value="true">
            {{ $t('noDataVisiteur') }}
          </v-alert>
        </div>
      </v-flex>
      <v-flex
        class="pa-0"
        :class="{
          'xs5': !bigWidthChat||!$vuetify.breakpoint.xsOnly,
          'xs12': bigWidthChat || !bigHeightChat || $vuetify.breakpoint.xsOnly,
          'chat-panel--reduce': !bigHeightChat
        }"
      >
        <wz-fenetre-chat
          v-if="dataCompletVisiteur && chatSessionActive"
          ref="fenetreChat"
          @reloadHistoChat="openChat"
          @bigChat="bigHeightChat = true"
          @smallChat="bigHeightChat = false"
          @bigWidthChat="bigWidthChat = true"
          @smallWidthChat="bigWidthChat = false"
          :datasVisiteur.sync="dataCompletVisiteur"
          :loadingChat="loadingChat"
          :msg.sync="msg"
          @sendReponseAttente=sendReponseAttente
          @chatSessionSelect="chatSessionSelected"
          @afficheInfosVisiteur="afficheInfosVis"
          @openScreensharing="visiteurId => $refs.infos.openScreensharing(visiteurId)"
        ></wz-fenetre-chat>
        <div v-else-if="!dataCompletVisiteur && chatSessionActive" class="flex">
          <v-alert type="warning" :value="true">
            {{ $t('noDataChat') }}
          </v-alert>
        </div>
      </v-flex>
      <div v-if="dataCompletVisiteur && (datasViewPupitre.visiteurDatas.newMessage && !datasViewPupitre.visiteurDatas.network && routeNameChatting) || dataCompletVisiteur && (datasViewPupitre.visiteurDatas.network && datasViewPupitre.visiteurDatas.networkFirstMessage)" class='dialogueNewChat'>
        <v-card class='ContentDialogNewChat'>
          <v-card-title class="primary white--text subheading">{{ $t('titreNewChat') }}</v-card-title>
          <v-card-text>
            {{ $t('txtContentNewChat') }} {{dataCompletVisiteur.visiteurID}}.
          </v-card-text>
          <v-spacer></v-spacer>
          <v-card-actions>
            <v-btn 
              class="blue--text darken-1" flat  @click="openFirstChat()">OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>

    </v-layout>
    <v-container
      fill-height
      v-if="dragOverStatus && dragOverElement.index != (dragOverElement.dataDrop.placePupitreActif-1)" 
    >
      <v-layout style="height:200px" align-center justify-center row>
        <v-card>
          <v-card-title class="primary white--text subheading">{{ $t('changePlace') }}</v-card-title>
          <v-card-text>
            <div v-html="changePlaceText"></div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
    <v-container
      fill-height
      v-else-if="dragOverStatus && dragOverElement.index == (dragOverElement.dataDrop.placePupitreActif-1)" 
    >
      <v-layout style="height:200px" align-center justify-center row>
        <v-card>
          <v-card-title class="primary white--text subheading">{{ $t('changePlace') }}</v-card-title>
          <v-card-text>
            <div v-html="changePlaceText2"></div>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import _watcheebox from '../watcheebox/watcheebox.js'
import _ from 'lodash'
// import WzModuleVisioAPZ from '../watcheezy/WzModuleVisioAPZ'
export default {
  // components: {
  //   WzModuleVisioAPZ
  // },
  props: [
    'datasViewPupitre',
    'placesPupitre',
    'selectedAgent',
    // 'firstOpenChat',
    'dragOverStatus',
    'dragOverElement'
  ], // Les donnés du parent (chatting.vue)

  data  () {
    return {
      loading: false,
      histoChat: [],
      loadingChat: false,
      chatSessionActive: this.datasViewPupitre.visiteurID,
      msg: '',
      /**
       * Indique si le chat est élargi
       */
      bigWidthChat: false,
      /**
       * Indique si le chat prend toute la hauteur
       */
      bigHeightChat: true,
      afficheInfos: false,
      // dataVisio: {},
      selectedMenuVisiteur: 'info' // par defaut la fiche visiteur
    }
  },

  methods: {
    // indication d'un chat selectionné
    chatSessionSelected (e) {
      console.log('session chat selected', e)
      this.chatSessionActive = e
      this.$emit('chatSessionSelect', e)
    },
    // // une visio est demarrée avec ce visiteur
    // startVisio (data) {
    //   this.dataVisio = data
    // },
    // // une visio est arretée avec ce visiteur
    // stopVisio () {
    //   this.dataVisio = {}
    // },
    // remonte le nouveau message pour mettre à jour l'historique de chat du visiteur offline
    sendReponseAttente (e) {
      // console.log('sendMessage dans view chat', e)
      this.$emit('MAJHistoChat', e)
    },
    afficheInfosVis () {
      // console.log('affiche i')
      this.afficheInfos = true
    },
    startVisio () {},
    stopVisio () {},
    cacheInfosVis () {
      this.afficheInfos = false
    },
    // Mise à jour du chat pour la section messages en attentes uniquement
    // MAJMessageAttente (e) {
    //   console.log('MAJMessageAttente', e)
    // },
    // Ouverture de la fenetre de chat
    openFirstChat () {
      // console.log('histoChat', histoChat)
      let visClone = _.cloneDeep(this.dataCompletVisiteur)
      visClone.newMessage = false
      // efface la fenetre uniquement pour les visiteur facebook
      if (this.datasViewPupitre.visiteurDatas && this.datasViewPupitre.visiteurDatas.network) {
        visClone.networkFirstMessage = false
      }
      // enregistre les donnée du visiteur dans le store
      this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', visClone)

      // supprime la/les notification(s), associée(s) au visiteur
      // quand l'agent ouvre le chat pour la premiere fois
      _.each(this.$store.state._Notifier.notifications, (notif, idx) => {
        // console.log('notif.data', notif.data)
        if (notif.data && notif.data.titre === this.datasViewPupitre.visiteurID) {
          this.$store.commit('_Notifier/REMOVE_NOTIF', idx)
        }
      })
    },

    // Ouverture de la fenetre de chat
    openChat () {
      this.loadingChat = true
      this.$emit('loading')

      // --------------- DEMANDE HISTORIQUE DE CHAT
      _watcheebox
        .firstLoadHistoChat({
          chatSession: this.dataCompletVisiteur.visiteurID,
          entrepriseId: this.user.entId
        })

        .then(histoChat => {
          // console.log('histoChat', histoChat)
          let visClone = _.cloneDeep(this.dataCompletVisiteur)
          visClone.histoChat = histoChat
          // enregistre les donnée du visiteur dans le store
          console.log('set visiteur openchat', visClone)
          this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', visClone)
          // console.log('openChat connectRoom', this.dataCompletVisiteur.visiteurID)
          // console.log('openChat connectRoom', this.dataCompletVisiteur.visiteurID)
          if (this.$route.fullPath !== '/trafic/attente' && this.$route.fullPath !== '/trafic/contact' && !this.directChat) {
            // affichage uniquement sur desktop
            if (!this.isMobile) {
              // this.showIframeMirroring(this.dataCompletVisiteur) // Affiche le mirroring
            }
          }
        })
        .catch(e => {
          console.error(e)
        })
        .then(_ => {
          this.loadingChat = false
        })
      // -------------------------------------------
    },

    // ----------------------------------------------------------------------------
    // Affiche le status visiteur
    // offline/online
    visiteurStatus (visiteurInfos) {
      console.log('visiteurStatus', visiteurInfos)
      // console.log(visiteurInfos)
      // var divCible = this.$el.firstChild
      var divCible = this.$el.getElementsByClassName('presenceVisiteur')[0]
      if (!divCible) return
      // Si le visiteur est online on cache la div
      if (visiteurInfos.status === 'online') {
        divCible.classList.remove('affiche')
        divCible.classList.add('cache')
        // Sinon le visiteur est offline on affiche la div
      } else {
        divCible.classList.remove('cache')
        divCible.classList.add('affiche')
      }
    }
  },

  watch: {
    // Au changement de status visiteur dans la view pupitre (online: true/flase)
    'datasViewPupitre.online': function (val, oldval) {
      this.visiteurStatus(this.pupitreInfosVisiteur) // Affiche/Cache la box visiteur offline
    },

    'dataCompletVisiteur.visiteurID' () {
      console.log('this.dataCompletVisiteur', this.dataCompletVisiteur)
      if (this.dataCompletVisiteur) {
        if (!this.dataCompletVisiteur.histoChat.length) {
          console.log('openChat', this.dataCompletVisiteur.visiteurID)
          this.openChat()
        }
      } else {
        console.log('visiteur plus la')
      }
    }
  },

  mounted () {
    // A l'ouverture de cette vu on inject le nouveau visiteur
    if (
      this.dataCompletVisiteur &&
      !this.dataCompletVisiteur.histoChat.length
    ) {
      this.openChat()
    }
  },

  beforeDestroy () {},

  computed: {
    ...mapState('_StoreWatcheeBox', [
      'listeAllVisiteurs',
      'sessionsPrivees',
      'mySocketID'
    ]),
    ...mapGetters('_User', ['user']),

    dataCompletVisiteur: {
      get () {
        var data
        // console.log('dataCompletVisiteur get :', this.datasViewPupitre.visiteurDatas)
        // uniquement pour la section messages en ettantes
        // il faut aller chercher le bon histochat du visiteur offline
        if (this.$route.fullPath === '/trafic/attente' || this.directChat) {
          let newData = _.clone(this.datasViewPupitre.visiteurDatas)
          let histoChatVisiteurMessageAttente = _.clone(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat)
          // console.log('histoChatVisiteurMessageAttente', histoChatVisiteurMessageAttente)
          newData.histoChat = histoChatVisiteurMessageAttente
          data = newData
        } else if (this.$route.fullPath === '/trafic/contact') {
          let newData = _.clone(this.datasViewPupitre.visiteurDatas)
          let histoChatVisiteurContact = _.clone(this.$store.state._StoreWatcheeBox.contactOpened.histoChat)
          // console.log('histoChatVisiteurContact', histoChatVisiteurContact)
          newData.histoChat = histoChatVisiteurContact
          data = newData
        // } else if (this.$route.fullPath === '/trafic/visitors') {
        //   data = _.clone(this.datasViewPupitre.visiteurDatas)
        //   data.placePupitre = 0
        } else {
          data = _.clone(this.datasViewPupitre.visiteurDatas)
          // data.histoChat = this.histoChat
        }
        // console.log('dataCompletVisiteur get :', data)
        return data
      },
      set (vis) {
        // console.log('dataCompletVisiteur set :', vis)
        this.histoChat = vis.histoChat
      }
    },

    routeNameChatting () {
      if (this.$route.fullPath === '/trafic/chatting') {
        return true
      } else {
        return false
      }
    },

    // compute des infos pupitre du visiteur
    pupitreInfosVisiteur () {
      var infosPupitre = _.find(this.listeAllVisiteurs, [
        'visiteurID',
        this.datasViewPupitre.visiteurDatas.visiteurID
      ])
      console.log('pupitreInfosVisiteur', infosPupitre)
      return {
        // donnés remontées par redis via nodejs
        status: infosPupitre.status,
        lang: infosPupitre.lang,
        visiteurID: infosPupitre.visiteurID,
        roomName: infosPupitre.roomName,
        socketID: infosPupitre.socketID,
        siteID: infosPupitre.siteID,
        notification: infosPupitre.notification,
        placePupitre: infosPupitre.placePupitre,
        histoChat: infosPupitre.histoChat,
        geoloc: infosPupitre.geoloc
      }
    },
    changePlaceText () {
      return `${this.$t('changePlaceContent1')} 
              <b>${this.datasViewPupitre.visiteurDatas.placePupitre}</b><br>
              ${this.$t('changePlaceContent2')} 
              <b>${this.datasViewPupitre.visiteurID}</b>.<br> 
              ${this.$t('askChangePlace')}`
    },
    changePlaceText2 () {
      return `${this.$t('changePlaceContent1')} 
              <b>${this.datasViewPupitre.visiteurDatas.placePupitre}</b><br>
              ${this.$t('txtNoChangePlace')}`
    }
  }
}
</script>
 
<style>
.infos-panel--large {
  height: calc(100% - 48px);
}
.chat-panel--reduce {
  height: 48px !important;
}
.posRelative {
  position: relative;
}
.ContentInfosVisiteurPupitre {
  height: 330px;
}
.morroringActif {
  height: 100%;
  bottom: 0;
  right: 0;
}
.dialogueNewChat {
  position: absolute;
  top: 0px;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.ContentDialogNewChat {
  position: absolute;
  width: 320px;
  height: 180px;
  top: calc(50% - 80px);
  left: calc(50% - 160px);
}
.mobileShowInfosVisiteur{
  min-width: 100% !important;
  left: 102%;
  position: absolute;
}
.afficheInfos{
  transition: left .5s ease-in-out;
  left: 0px;
}
.cacheInfos{
  transition: left .5s ease-in-out;
  left: 102%;
}
</style>



// WEBPACK FOOTER //
// src/components/watcheebox/WzViewChat.vue